"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useStyles = void 0;
var react_1 = __importStar(require("react"));
var core_1 = require("@material-ui/core");
var styles_1 = require("@material-ui/core/styles");
var icons_1 = require("@material-ui/icons");
var classnames_1 = __importDefault(require("classnames"));
var react_intl_1 = require("react-intl");
var NotificationsContext_1 = require("../../context/NotificationsContext");
var constants_1 = require("../../constants");
exports.useStyles = styles_1.makeStyles(function (theme) {
    var notificationsPanel = theme.variables.palette.notificationsPanel;
    var status = notificationsPanel.status;
    return {
        wrapper: {
            position: 'relative',
        },
        titleWrapper: {
            maxWidth: 'calc(100% - 65px)',
        },
        title: {
            display: function (_a) {
                var isOpen = _a.isOpen;
                return (isOpen ? "block" : '-webkit-box');
            },
            '-webkit-box-orient': 'vertical',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'normal',
            '-webkit-line-clamp': function (_a) {
                var isOpen = _a.isOpen;
                return (isOpen ? 'none' : 1);
            },
            height: function (_a) {
                var isOpen = _a.isOpen, fullHeight = _a.fullHeight;
                return (isOpen ? fullHeight + "px" : constants_1.defaultSubjectHeight + "px");
            },
            lineHeight: 'normal',
            transition: theme.transitions.create('height', {
                easing: theme.transitions.easing.sharp,
                duration: theme.transitions.duration.enteringScreen,
            }),
            fontSize: 15,
            fontWeight: function (_a) {
                var viewed = _a.viewed;
                return (viewed ? 500 : 700);
            },
        },
        actionsPanel: {
            position: 'absolute',
            top: 0,
            right: 0,
        },
        notificationStatus: {
            border: "1px solid " + status.border,
            borderRadius: '50%',
            width: 15,
            height: 15,
            transition: theme.transitions.create('background', {
                easing: theme.transitions.easing.easeInOut,
                duration: theme.transitions.duration.short,
            }),
            cursor: 'pointer',
            '&:not(.viewed)': {
                background: status.active,
            },
            '&.viewed': {
                background: theme.palette.background.paper,
            },
        },
        deleteButton: {
            paddingTop: '4px',
            background: 'none',
            border: 'none',
        },
        closeIcon: {
            width: '22px',
            height: '22px',
        },
    };
});
var NotificationCardHeader = function (props) {
    var subjectMessage = props.subjectMessage, viewed = props.viewed, isOpen = props.isOpen, id = props.id, setNeedSubjectCollapse = props.setNeedSubjectCollapse;
    var _a = react_1.useContext(NotificationsContext_1.NotificationsContext), deleteNotification = _a.deleteNotification, toggleViewed = _a.toggleViewed;
    var subjectMessageRef = react_1.useRef(null);
    var _b = react_1.useState(constants_1.defaultSubjectHeight), fullHeight = _b[0], setFullHeight = _b[1];
    var _c = react_1.useState(false), isDeleteDisabled = _c[0], setIsDeleteDisabled = _c[1];
    var classes = exports.useStyles({ viewed: viewed, isOpen: isOpen, fullHeight: fullHeight });
    react_1.useEffect(function () {
        if (!subjectMessageRef || !subjectMessageRef.current) {
            return;
        }
        var _a = subjectMessageRef.current, scrollHeight = _a.scrollHeight, clientHeight = _a.clientHeight;
        setFullHeight(scrollHeight);
        setNeedSubjectCollapse(scrollHeight !== clientHeight);
    }, [subjectMessageRef, setFullHeight, setNeedSubjectCollapse, viewed]);
    var enableDeleteBtn = function () {
        setIsDeleteDisabled(false);
    };
    var handleDelete = react_1.useCallback(function () {
        setIsDeleteDisabled(true);
        deleteNotification(id, viewed, enableDeleteBtn);
    }, [id, deleteNotification, viewed, setIsDeleteDisabled]);
    var handleToggleViewed = react_1.useCallback(function () { return toggleViewed(id, !viewed); }, [id, toggleViewed, viewed]);
    return (react_1.default.createElement(core_1.Grid, { container: true, spacing: 1, justify: "space-between", alignItems: "center", wrap: "nowrap", className: classes.wrapper },
        react_1.default.createElement(core_1.Grid, { item: true, className: classes.titleWrapper },
            react_1.default.createElement(core_1.Typography, { ref: subjectMessageRef, component: "h2", className: classes.title + " notification-card__title" }, subjectMessage)),
        react_1.default.createElement(core_1.Grid, { item: true, className: classes.actionsPanel },
            react_1.default.createElement(core_1.Grid, { container: true, spacing: 2, alignItems: "center", wrap: "nowrap" },
                react_1.default.createElement(core_1.Grid, { item: true },
                    react_1.default.createElement(core_1.Tooltip, { title: react_1.default.createElement(react_intl_1.FormattedMessage, { id: viewed ? 'markAsNotViewed' : 'markAsViewed' }) },
                        react_1.default.createElement("div", { onClick: handleToggleViewed, className: classnames_1.default(classes.notificationStatus, 'notification-status', {
                                viewed: viewed,
                            }) }))),
                react_1.default.createElement(core_1.Grid, { item: true, container: true },
                    react_1.default.createElement("button", { disabled: isDeleteDisabled, onClick: handleDelete, className: classes.deleteButton + " delete-notification" },
                        react_1.default.createElement(icons_1.Close, { fontSize: "small", className: "" + classes.closeIcon })))))));
};
exports.default = NotificationCardHeader;
